import {downloadExcel} from "react-export-table-to-excel";
import {getFinishedReservation} from "../../services/reservation/reservation";
import {appendServiceFilterParams} from "../shared/filters/service_filter_container";

const COLUMNS = [
  ["#", (_, index) => index + 1],
  ["کاربر", row => row.person_name],
  ["شماره تماس کاربر", row => row.person_phone],
  ["مباشر", row => row.agent_name],
  ["شماره تماس مباشر", row => row.agent_phone],
  ["گرایش", row => row.branch_title],
  ["مبلغ کل", row => row.price],
  ["سهم مشاور", row => row.agent_share],
  ["تاریخ", row => row.date],
  ["زمان شروع", row => row.start_time],
  ["زمان پایان", row => row.end_time],
  ["مدت", row => row.duration],
];

export async function exportConsultationPayments(filters, sortBy, sortType) {
  const params = new URLSearchParams({
    sort_by: sortBy,
    sort_type: sortType === false ? "DESC" : "ASC",
    limit: 500,
    offset: 0,
  });
  appendServiceFilterParams(params, filters);

  const rows = [];
  let total;
  do {
    params.set("offset", rows.length);
    const response = await getFinishedReservation(params.toString());
    const batch = response?.data?.consultationPaymentList ?? [];
    if (response?.status !== 200 || !Array.isArray(batch)) {
      throw new Error("Unable to load consultation settlements");
    }
    total = Number(response.data?.total_count);
    if (!Number.isInteger(total) || total < 0 || (batch.length === 0 && rows.length < total)) {
      throw new Error("Incomplete consultation settlements export");
    }
    rows.push(...batch);
  } while (rows.length < total);

  const table = document.createElement("table");
  table.dir = "rtl";
  const header = table.createTHead().insertRow();
  COLUMNS.forEach(([title]) => {
    const cell = document.createElement("th");
    cell.textContent = title;
    header.appendChild(cell);
  });
  const body = table.createTBody();
  rows.forEach((row, index) => {
    const tableRow = body.insertRow();
    COLUMNS.forEach(([, value]) => {
      const cell = tableRow.insertCell();
      const content = value(row, index);
      cell.textContent = content ?? "";
      // Preserve phone prefixes and dates, and treat user-entered text as text.
      if (typeof content !== "number") cell.setAttribute("style", 'mso-number-format:"\\@"');
    });
  });

  downloadExcel({fileName: "consultation-settlements.xls", sheet: "تسویه مشاوره"}, table);
}
